import { Link } from "react-router-dom";

export default function FreeGuideThankYouPage() {
  return (
    <div style={{ minHeight: "100vh" }}>
      {/* Announcement */}
      <div className="announcement-bar">
        <div className="container">
          <span>SUCCESS! YOUR FREE GUIDE HAS BEEN DISPATCHED TO YOUR INBOX</span>
        </div>
      </div>

      {/* Main Content */}
      <section className="section-padding" style={{ minHeight: "80vh", display: "flex", alignItems: "center" }}>
        <div className="container" style={{ maxWidth: "860px", textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: "16px" }}>✉️</div>
          <h1 style={{ fontSize: "3.2rem", marginBottom: "16px" }}>
            YOUR GUIDE IS <span className="text-gold">ON ITS WAY.</span>
          </h1>
          <p style={{ fontSize: "1.15rem", color: "var(--text-secondary)", maxWidth: "640px", margin: "0 auto 36px auto" }}>
            Check your email inbox for <strong>The Loop You Live In</strong>. If it doesn't arrive in a few minutes, check your spam or promotions folder. While your download arrives, explore the next step in your identity transformation.
          </p>

          {/* Upsell Box */}
          <div style={{ background: "var(--navy-card)", border: "1px solid var(--border-gold)", borderRadius: "var(--radius-xl)", padding: "48px", textAlign: "left", boxShadow: "var(--shadow-card)", marginBottom: "48px" }}>
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <div className="hero-kicker">YOU'VE EXPERIENCED THE FIRST SHIFT</div>
              <h2 style={{ fontSize: "2.4rem", marginTop: "8px" }}>Ready to Go Deeper?</h2>
              <p style={{ color: "var(--text-secondary)", fontSize: "1.05rem", marginTop: "8px" }}>
                The free guide introduces the first layer. The Complete System gives you the full framework and daily practice tools.
              </p>
            </div>

            <div className="offer-grid">
              <div>
                <h3 className="font-serif" style={{ fontSize: "1.8rem", color: "var(--gold-warm)", marginBottom: "16px" }}>The Complete Identity Shift™ System</h3>
                <ul className="stack-list">
                  <li><span>Book 1: The Pattern of You</span></li>
                  <li><span>Book 2: The Probability of You</span></li>
                  <li><span>Book 3: The Inheritance of You</span></li>
                  <li><span>Wealth Journal (30-Day Practice)</span></li>
                  <li><span>Success Journal (30-Day Practice)</span></li>
                  <li><span>Health Journal (30-Day Practice)</span></li>
                  <li><span>Relationships Journal (30-Day Practice)</span></li>
                  <li><span>Daily Practice Kit (5-Step System &amp; Cards)</span></li>
                </ul>
              </div>

              <div className="price-anchor-box">
                <div style={{ fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "0.1em", color: "var(--gold-warm)", fontWeight: 700 }}>The Complete Collection</div>
                <div style={{ margin: "16px 0" }}>
                  <span className="price-main">$47</span>
                </div>

                <p style={{ fontSize: "0.85rem", color: "var(--text-muted)", margin: "20px 0" }}>
                  8 Digital Products • Instant PDF Downloads
                </p>

                <Link to="/checkout?product=identity-shift-collection" className="btn btn-primary-gold btn-lg" style={{ width: "100%" }}>
                  GET THE COMPLETE SYSTEM ($47) →
                </Link>
              </div>
            </div>
          </div>

          <div>
            <Link to="/" style={{ color: "var(--text-muted)", textDecoration: "none", fontSize: "0.9rem" }}>Back to Main Home →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
